import React from 'react';
import PropTypes from 'prop-types';
import styles from './search.module.scss.js';
import { SuggestedSearch } from './suggested.js';

/* eslint-disable camelcase */
function SearchMenu(_ref) {
  let {
    searched,
    tracking,
    suggestionWrapRef,
    edition,
    pageType,
    useUnitTracking
  } = _ref;
  let trackingPos = 1;
  const subunitTrackingLayer = () => ({
    ...tracking,
    subunit_type: 'component',
    subunit_name: 'search_menu',
    position_in_subunit: trackingPos++
  });
  if (!searched) {
    return '';
  }
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles.wrapper} ${pageType !== 'default' ? styles.categoriesPageWrapper : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    ref: suggestionWrapRef
  }, edition === 'en-us' && /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement(SuggestedSearch, {
    tracking: subunitTrackingLayer(),
    useUnitTracking: useUnitTracking
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.pageOverlay
  }));
}
SearchMenu.propTypes = {
  query: PropTypes.string,
  searchUrl: PropTypes.string,
  searchUrlBase: PropTypes.string,
  searched: PropTypes.bool,
  tracking: PropTypes.object
};

export { SearchMenu, SearchMenu as default };
